import React, {useEffect} from "react";
import {useWauth} from "../auth/WauthProvider";

const LoginPage = () => {

  const {loginWithRedirect} = useWauth();

  useEffect(() => {
    loginWithRedirect()
  }, [])

  return (
    <div>Cargando...</div>
  )
};

export default LoginPage;
